import { addToChainAfter, HandlerWithResult } from "@insite/client-framework/HandlerCreator";
import { chain, DispatchSetProductFilters, RemoveStockedItemsFilter } from "@insite/client-framework/Store/Pages/ProductList/Handlers/RemoveProductFilters";
import { CustomHandlerWithResult } from "@WhiteCap/Store/CustomHandlerCreator/CustomHandlerCreator";
import { ProductFiltersExtended } from "@WhiteCap/Store/Reducer/WhiteCapReducer/ProductListIsStockAvailableReducer";

type HandlerType = CustomHandlerWithResult<ProductFiltersExtended, ProductFiltersExtended>;

export const RemoveStockedAtBranchFilter: HandlerType = props => {
    if (props.parameter.isInStockAtBranch !== undefined) {
        props.result.isInStockAtBranch = undefined;
    }
};

export const DispatchIsInStockFilter: HandlerType = props => {
    props.dispatch({
        type: "Custom/ProductList/IsStockAvailable/SetIsInStockAtBranch",
        data: props.result,
    });
};

addToChainAfter(
    chain as HandlerWithResult<ProductFiltersExtended, ProductFiltersExtended>[],
    RemoveStockedItemsFilter,
    RemoveStockedAtBranchFilter as HandlerWithResult<ProductFiltersExtended, ProductFiltersExtended>
);

addToChainAfter(
    chain as HandlerWithResult<ProductFiltersExtended, ProductFiltersExtended>[],
    DispatchSetProductFilters,
    DispatchIsInStockFilter as HandlerWithResult<ProductFiltersExtended, ProductFiltersExtended>
);